var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.errors),function(error,index){return _c('b-alert',{key:index,attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(error)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }